import Vue from 'vue'
const echarts = require('echarts');
require('../static/js/encodeChina.js');
Vue.prototype.$echarts = echarts // 引入组件（将echarts注册为全局）